<template>
	<v-list-item
		v-bind="$attrs"
		@click="$emit('click', $event)"
		v-on="other_listeners"
	>
		<slot></slot>
	</v-list-item>
</template>

<script>
export default {
	name: 'KListItem',
	inheritAttrs: false,
	computed: {
		other_listeners() {
			const { click, ...rest } = this.$listeners;
			return rest;
		},
	},
};
</script>
